import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "@/pwa/Nav";
import Hero from "@/pwa/Hero";
import About from "@/pwa/About";
import Gallery from "@/pwa/Gallery";
import Process from "@/pwa/Process";
import WhyChooseUs from "@/pwa/WhyChooseUs";
import Testimonials from "@/pwa/Testimonials";
import QuoteForm from "@/pwa/QuoteForm";
import FinalCta from "@/pwa/FinalCta";
import FAQ from "@/pwa/FAQ";
import Footer from "@/pwa/Footer";

import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import { RequireAdmin, RedirectIfAuthed } from "@/admin/Guards";

const Landing = () => {
  return (
    <main className="bg-[#FAF9F6] text-[#1A1A1A] overflow-x-hidden">
      <Nav />
      <Hero />
      <About />
      <Gallery />
      <Process />
      <WhyChooseUs />
      <Testimonials />
      <QuoteForm />
      <FinalCta />
      <FAQ />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/admin"
            element={
              <RedirectIfAuthed>
                <AdminLogin />
              </RedirectIfAuthed>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              color: "#FAF9F6",
              border: "1px solid rgba(193,154,107,0.35)",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
